<template>
  <v-container>
    <v-toolbar>
      <v-toolbar-title
        >space<b>studio</b>™ Administration Panel</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text @click="announceForm()">Update announce</v-btn>
        <v-btn text @click="backToExoops()"
          >Back to &nbsp;space<b>studio</b>™</v-btn
        >
        <v-btn text @click="logout()">Logout</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-dialog width="600" v-model="announceDialog">
      <v-card>
        <v-card-title :style="backgroundStarStyle" class="headline white--text">
          <span>Update announce</span>
          <v-spacer></v-spacer>
          <v-btn icon dark class="m-0" @click="announceDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pl-5 pd-5">
          <v-form>
            <v-text-field
              name="message"
              label="Message"
              type="text"
              v-model="announce.message"
            ></v-text-field>
            <v-select
              label="Type"
              :items="announceTypes"
              v-model="announce.type"
            ></v-select>
            <v-text-field
              name="expirationDateYYYYMMDD"
              label="Expiration date (YYYY-MM-DD)"
              type="text"
              v-model="announce.expirationDateYYYYMMDD"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider class="p-0 m-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" text @click="updateAnnounce"> UPDATE </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      class="admin-data-table"
      :headers="this.tableFields"
      :items="this.usersExtended"
      :search="search"
      :footer-props="{ itemsPerPageOptions: rowsPerPageItems }"
      :options.sync="pagination"
      fix-header
    >
      <template v-slot:item="row">
        <tr>
          <td :class="`${row.item.deprecated === true ? 'red--text' : ''}`">
            {{ row.item.email ? row.item.email : '[GROUP]' }}
          </td>
          <td
            v-if="row.item.role !== 'GROUP'"
            :class="`${row.item.deprecated === true ? 'red--text' : ''}`"
          >
            {{
              row.item.firstName +
              ' ' +
              row.item.lastName +
              ' (' +
              row.item.organization +
              ')'
            }}
          </td>
          <td
            v-if="row.item.role === 'GROUP'"
            :class="`${row.item.deprecated === true ? 'red--text' : ''}`"
          >
            {{ row.item.groupName }}
          </td>
          <td :class="`${row.item.deprecated === true ? 'red--text' : ''}`">
            {{ row.item.role }}
          </td>
          <td>
            <div v-if="row.item.optionsEditable">
              <v-select
                v-on:keyup.enter="$event.stopPropagation()"
                :multiple="true"
                v-on:change="updateOptions(row.item)"
                :items="allOptions"
                v-model="row.item.options"
                chips
              >
              </v-select>
            </div>
          </td>
          <td
            :class="
              isAboutExpire(row.item.expiration)
                ? 'red darken-1 white--text text-center'
                : 'text-center'
            "
          >
            {{ row.item.expiration ? row.item.expiration : 'none' }}<br />
            <span style="color: #fff !important; opacity: 0.7">{{
              isAboutExpire(row.item.expiration)
                ? '(' + timeLeftExpire(row.item.expiration) + 'd left)'
                : ''
            }}</span>
          </td>
          <td>
            <v-dialog v-model="row.item.dialogDelete" width="500">
              <template v-slot:activator="{ on }">
                <v-btn small v-on="on">Delete</v-btn>
              </template>
              <v-card>
                <v-card-title
                  :class="
                    'headline ' + this.$vuetify.theme.dark
                      ? 'grey darken-3'
                      : 'grey lighten-2'
                  "
                  primary-title
                >
                  Delete User
                </v-card-title>

                <v-card-text>
                  You are about to delete a user : {{ row.item.email }}, please
                  confirm
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    outlined
                    @click="deleteUser(row.item)"
                  >
                    Delete
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="row.item.dialogDelete = undefined"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
          <td>
            <v-dialog v-model="row.item.dialogRestoreBackup" width="500">
              <template v-slot:activator="{ on }">
                <v-btn v-if="row.item.email" small v-on="on">
                  Restore backup
                </v-btn>
                <v-btn v-if="!row.item.email" small disabled>
                  Restore backup
                </v-btn>
              </template>
              <v-card>
                <v-card-title
                  :class="
                    'headline ' + this.$vuetify.theme.dark
                      ? 'grey darken-3'
                      : 'grey lighten-2'
                  "
                  primary-title
                >
                  Restore Backup
                </v-card-title>

                <v-card-text>
                  You are about to restore a backup for the following user :
                  {{ row.item.email }}, please confirm
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    outlined
                    @click="restoreBackup(row.item)"
                  >
                    Restore backup
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="row.item.dialogRestoreBackup = undefined"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
          <td>
            <v-dialog v-model="row.item.dialogResetToDemo" width="500">
              <template v-slot:activator="{ on }">
                <v-btn v-if="row.item.email" small v-on="on">
                  Reset to Demo
                </v-btn>
                <v-btn v-if="!row.item.email" small disabled>
                  Reset to Demo
                </v-btn>
              </template>
              <v-card>
                <v-card-title
                  :class="
                    'headline ' + this.$vuetify.theme.dark
                      ? 'grey darken-3'
                      : 'grey lighten-2'
                  "
                  primary-title
                >
                  Reset to Demo
                </v-card-title>

                <v-card-text>
                  You are about to reset to demo the following user :
                  {{ row.item.email }}, please confirm
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    outlined
                    @click="resetToDemo(row.item)"
                  >
                    Reset to demo
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="row.item.dialogResetToDemo = undefined"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import navigationComponents from '../components/navigationComponents.js'

export default {
  name: 'admin',

  mounted() {
    this.updateOptionsList()
    this.updateUserList()
    this.updateGuardianUsersList()
  },

  computed: {
    ...mapGetters({ currentUser: 'currentUser' }),

    allOptions() {
      let allOptions = []
      for (let option of this.options) {
        allOptions.push({
          text: this.convertOptionToTLA(option),
          value: option
        })
      }
      return allOptions
    },

    backgroundStarStyle() {
      return navigationComponents.backgroundStarStyle()
    },
    usersExtended() {
      let usersExtended = []
      this.users.forEach((user) => {
        let userExtended = JSON.parse(JSON.stringify(user))
        let find = false
        if (userExtended.role !== 'GROUP') {
          for (let guardianUser of this.guardianUsers) {
            if (guardianUser._id === userExtended.id) {
              find = true
            }
          }
          userExtended.deprecated = !find
          if (!find) {
            userExtended.role = 'LOST'
          }
          userExtended.optionsEditable = userExtended.role === 'USER'
        } else {
          for (let userGroupeId in userExtended.users) {
            if (userExtended.users[userGroupeId] === 'ADMIN') {
              find = true
            }
          }
          userExtended.deprecated = !find
          if (!find) {
            userExtended.role = 'NO ADMIN IN GROUP'
          }
        }
        usersExtended.push(userExtended)
      })
      return usersExtended
    }
  },

  data() {
    return {
      errorguardianUsers: '',
      guardianUsers: [],
      users: [],
      options: [],
      tableFields: [
        { value: 'email', text: 'Email', sortable: true },
        { value: 'name', text: 'Name', sortable: true },
        { value: 'role', text: 'Role', sortable: true },
        { value: 'options', text: 'Options', sortable: true },
        { value: 'expiration', text: 'Expiration', sortable: true },
        { value: 'delete', text: 'Delete', sortable: true },
        { value: 'restore', text: 'Restore (user only)', sortable: true },
        { value: 'reset', text: 'Reset (user only)', sortable: true }
      ],
      search: '',
      rowsPerPageItems: [25, 50, 150, { text: 'All', value: -1 }],
      pagination: {
        rowsPerPage: -1
      },

      announce: {
        message: '',
        type: 'info',
        expirationDateYYYYMMDD: ''
      },
      announceDialog: false,
      announceTypes: ['info', 'success', 'warning', 'error']
    }
  },

  methods: {
    async restoreBackup(user) {
      user.dialogRestoreBackup = undefined
      await this.$http.put('users/' + user.id + '/restoreBackup')
      this.updateUserList()
    },
    async resetToDemo(user) {
      user.dialogResetToDemo = undefined
      await this.$http.put('users/' + user.id + '/resetToDemo')
      this.updateUserList()
    },

    convertOptionToTLA(label) {
      switch (label) {
        case 'CONSTELLATIONS_ADVANCED':
          return 'CST*'
        case 'PARAMETRIC_STUDIES':
          return 'PAR'
        case 'CONSTELLATIONS':
          return 'CST'
        case 'DEPLOYMENT_STRATEGIES':
          return 'DEP'
        case 'SIMULATIONS':
          return 'SIM'
        case 'SCRIPTING':
          return 'SCR'
        case 'DEFENSE':
          return 'DEF (!)'
        case 'ASTERX':
          return 'AST (!)'
        case 'AAP_IA':
          return 'DELFOX (!)'
        default:
          return 'UKN'
      }
    },

    async updateOptions(user) {
      await this.$http.put('users/' + user.id + '/options', user.options)
      // this.updateUserList() no need to refresh, the list is localy up to date
    },

    updateUserList() {
      this.$http
        .get('/users/')
        .then((response) => {
          this.users = response.data
        })
        .catch((e) => {})
    },
    updateOptionsList() {
      this.$http
        .get('/users/options')
        .then((response) => {
          this.options = response.data
        })
        .catch((e) => {})
    },
    updateGuardianUsersList() {
      Vue.axios
        .get('/users/guardian')
        .then((response) => {
          this.guardianUsers = response.data
        })
        .catch((error) => {
          this.errorguardianUsers = error.response.data
        })
    },
    async logout() {
      delete localStorage.token
      await this.$store.dispatch('logout')
      this.$router.push('/')
    },
    async deleteUser(user) {
      let id = user.id
      if (id === '') {
        console.log('Error while trying to delete user, no userid')
        return
      }
      user.dialogDelete = undefined
      await this.$http.delete('/users/' + id)
      this.updateUserList()
    },
    backToExoops() {
      // be sure to not have the side bar
      delete localStorage.currentMissionId
      this.$router.push('/missions')
    },
    announceForm() {
      Vue.axios.get('/users/announce').then((response) => {
        let today = new Date()
        let todayYYYYMMDD = today.toISOString().split('T')[0]
        if (response.data !== null) {
          this.announce.expirationDateYYYYMMDD =
            response.data.expirationDateYYYYMMDD
          this.announce.message = response.data.message
          this.announce.type = response.data.type
        } else {
          this.announce.message = ''
          this.announce.type = 'info'
          this.announce.expirationDateYYYYMMDD = todayYYYYMMDD
        }
        this.announceDialog = true
      })
    },

    async updateAnnounce() {
      await this.$http.put('users/announce', this.announce)
      this.announceDialog = false
    },

    isAboutExpire(expiration) {
      let current = new Date()
      if (expiration) {
        let expire = new Date(expiration)
        let daysRemain = Math.floor((expire - current) / (1000 * 3600 * 24))
        if (daysRemain <= 30) {
          return true
        }
      }
      return false
    },

    timeLeftExpire(expiration) {
      let current = new Date()
      if (expiration) {
        let expire = new Date(expiration)
        let daysRemain = Math.floor((expire - current) / (1000 * 3600 * 24))
        return daysRemain
      }
      return 0
    },

    onCopy: function (e) {
      alert('Copied !')
    },
    onError: function (e) {
      alert('Failed to copy')
    }
  }
}
</script>

<style scoped>
.admin-data-table {
  display: flex;
  flex-direction: column;
}

.admin-data-table .v-datatable.v-table {
  order: -1;
}
</style>
